<div mat-dialog-title class="change-site-state">
  Layer Select
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>
  <p>You have selected multiple layers. Please choose a layer to select:</p>
  <form [formGroup]="selectLayerForm" class="site-form">
    <mat-form-field class="layer-select">
      <mat-select formControlName="layer" placeholder="Select a layer">
        <mat-option *ngFor="let option of options" [value]="option">
          {{ option }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions>
  <button
    data-cy="button-yes"
    mat-raised-button
    color="primary"
    class="green-shadow-button"
    (click)="onYesClick()">
    Apply
  </button>
</div>
